
import { MetabaseProvider, InteractiveQuestion } from "@metabase/embedding-sdk-react";
import { authConfig } from '../config/metabaseConfig';
import './MetabaseWidget.css';

/**
 * MetabaseWidget Component
 * Embeds a single Metabase question/card as a dashboard widget
 *
 * @param {number} questionId - The ID of the Metabase question to embed
 * @param {string} title - Widget title
 * @param {string} subtitle - Widget subtitle/description
 */
const MetabaseWidget = ({ questionId, title, subtitle }) => {
  return (
    <div className="metabase-widget">
      <div className="widget-header">
        <div className="widget-title">{title}</div>
        <div className="widget-actions">
          <span className="widget-action">🔍</span>
          <span className="widget-action">⚙️</span>
        </div>
      </div>
      {subtitle && <div className="widget-subtitle">{subtitle}</div>}
      <div className="metabase-question-container">
        <MetabaseProvider authConfig={authConfig}>
          <InteractiveQuestion
            questionId={questionId}
            withTitle={false}
          />
        </MetabaseProvider>
      </div>
    </div>
  );
};

export default MetabaseWidget;
